import React, { memo,forwardRef, useImperativeHandle, useRef, useMemo } from 'react';
import { Form, Input } from 'antd';
import { Formik, FormikProps } from 'formik';
import * as yup from 'yup';
import { QuerySearch } from '../form/query-search';
import { UserApi } from '../../apis';
import { BRANCH_CYR_NAME, BRANCH_LATIN_NAME } from '../valuation/custom';

const validationSchema = yup.object().shape({
  name: yup
    .string()
    .matches(BRANCH_CYR_NAME, 'Зөвхөн кирилл үсэг оруулна уу')
    .required('Нэр заавал оруулна'),
  nameEng: yup
    .string()
    .matches(BRANCH_LATIN_NAME, 'Зөвхөн латин үсэг оруулна уу')
    .required('Англи нэр заавал оруулна'),
});

type FormValues = {
  name: string | undefined;
  nameEng: string | undefined;
};

type Props = {
  onSubmit: (values: any) => void;
  action: any;
};

export type BranchFormRef = {
  submitForm: () => any;
  getValues: () => any;
};

const BranchForm = memo(
  forwardRef<BranchFormRef, Props>(({ onSubmit: _onSubmit, action }, ref) => {
    const formikRef = useRef<FormikProps<FormValues>>(null);

    useImperativeHandle(ref, () => ({
      submitForm: async () => {
        const validate = await formikRef.current?.submitForm();
        return validate;
      },
      getValues: () => {},
    }));

    const initialValues = useMemo(() => {
      return {
        name: undefined,
        nameEng: undefined,
        ...(action && {
          name: action.name,
          nameEng: action.nameEng,
          headId: action.head.id
        }),
      };
    }, [action]);

    return (
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={_onSubmit}
        innerRef={formikRef}
      >
        {({ handleChange, values, errors, touched, setFieldValue }) => {
          return (
            <>
              <Form layout="vertical">
                <div className="card">
                  <div className="inputContainer">
                    <Form.Item
                      label="Захирал"
                      layout="vertical"
                      validateStatus={errors.headId && touched.headId ? 'error' : ''}
                      help={
                        errors.headId && touched.headId ? errors.headId : ('' as any)
                      }
                    >
                      <QuerySearch
                        value={values.headId}
                        onChange={(e) => setFieldValue('headId', e)}
                        placeholder="Захирал"
                        showSearch
                        loadData={UserApi.select}
                      />
                    </Form.Item>

                    <div className="h-[13px]" />

                    <div className="flex flex-row">
                      <div className="flex-1">
                        <Form.Item
                          label="Нэр"
                          layout="vertical"
                          validateStatus={errors.name && touched.name ? 'error' : ''}
                          help={errors.name && touched.name ? errors.name : ('' as any)}
                        >
                          <Input
                            name="name"
                            value={values.name}
                            onChange={handleChange}
                            placeholder="Нэр"
                            status={touched.name && errors.name ? 'error' : ''}
                          />
                        </Form.Item>
                      </div>
                      <div className="w-[13px]" />
                      <div className="flex-1">
                        <Form.Item
                          label="Англи нэр"
                          layout="vertical"
                          validateStatus={errors.nameEng && touched.nameEng ? 'error' : ''}
                          help={errors.nameEng && touched.nameEng ? errors.nameEng : ('' as any)}
                        >
                          <Input
                            name="nameEng"
                            value={values.nameEng}
                            onChange={handleChange}
                            placeholder="Англи нэр"
                            status={touched.nameEng && errors.nameEng ? 'error' : ''}
                          />
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="h-[20px]" />
              </Form>
            </>
          );
        }}
      </Formik>
    );
  })
);

BranchForm.displayName = 'BranchForm';

export { BranchForm };
